<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <h3 class="mx-auto">
            Manage ASOs
          </h3>
          <v-spacer></v-spacer>
          <v-text-field
              v-model="search"
              color="accent"
              label="Search ASOs"
              single-line
            ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :search="search"
            :loading="loading"
            item-key="uid"
            :items="asos"
            :headers="headers"
          >
            <template v-slot:item.actions="{ item }">
              <v-btn :to="`/app/asos/edit/${item.uid}`" icon>
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>
              <v-btn @click="sureToDeleteDialog = true;asoToDelete = item.uid" icon>
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-snackbar v-model="success.status" top>
        {{success.message}}
        <v-btn color="success" text @click="success.status = false">
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar v-model="error.status" top>
        {{error.message}}
        <v-btn color="error" text @click="error.status = false">
          Close
        </v-btn>
      </v-snackbar>
      <v-dialog
        v-model="sureToDeleteDialog"
        persistent
      >
        <v-card>
          <v-card-title :style="{color: accentColor}" class="headline">DELETE!</v-card-title>
          <v-card-text
            :style="{color: accentColor}"
            color="accent"
          >
            Are you sure to DELETE?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" @click="sureToDeleteDialog = false">Cancel</v-btn>
            <v-btn color="accent" @click="deleteASO(asoToDelete)">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      asos: [],
      loading: false,
      search: '',
      sureToDeleteDialog: false,
      asoToDelete: true,
      success: {
        status: false,
        message: '',
      },
      error: {
        status: false,
        message: '',
      },
    };
  },
  methods: {
    async getASOs() {
      // Fetch ASOs here
      this.loading = true;
      const { asos } = this;
      const asosQuery = await this.firebase.firestore().collection('asos').get();
      asosQuery.forEach(async (item) => {
        asos.push({ uid: item.id, ...await item.data() });
      });
      // this.asos = asos;
      this.loading = false;
    },
    async deleteASO(uid) {
      // here delete the ASO
      try {
        await this.firebase.firestore().collection('asos').doc(uid).delete();
        this.success.status = true;
        this.success.message = 'ASO Deleted Successfully';
        this.sureToDeleteDialog = false;
        this.asos = [];
        this.getASOs();
      } catch (error) {
        console.log(error);
        this.error.status = true;
        this.error.message = 'Unknown Error! Please try again later.';
      }
    },
  },
  computed: {
    accentColor() {
      return this.$vuetify.theme.themes.light.accent;
    },
    headers() {
      return [
        {
          text: 'ASO ID',
          value: 'id',
        },
        {
          text: 'ASO Name',
          value: 'name',
        },
        {
          text: 'ASO Email',
          value: 'email',
        },
        {
          text: 'ASO Phone',
          value: 'phone',
        },
        {
          text: 'OTC Code',
          value: 'otcCode',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ];
    },
  },
  mounted() {
    this.getASOs();
  },
};
</script>
